import { useEffect } from "react";

const useEscapeKeyExit = ({
  active,
  close,
}: {
  active: boolean;
  close: () => void;
}) => {
  useEffect(() => {
    const handleEscapePress = (e: any) => {
      if (e.key === "Escape") {
        close();
        e.preventDefault();
      }
    };

    window.removeEventListener("keydown", handleEscapePress);

    if (active) {
      window.addEventListener("keydown", handleEscapePress);

      return () => {
        window.removeEventListener("keydown", handleEscapePress);
      };
    }
  }, [active, close]);

  return null;
};

export default useEscapeKeyExit;
